import React from "react";
import propTypes from "prop-types";

import HomeIcon from "@material-ui/icons/Home";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
// import DashboardIcon from "@material-ui/icons/Dashboard";
// import ShoppingCartI con from "@material-ui/icons/ShoppingCart";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
// import HomeIcon from "@material-ui/icons/Home";
import PackageIcon from "@material-ui/icons/AspectRatio";
import MoneyIcon from "@material-ui/icons/AttachMoney";
// import MovementsIcon from "@material-ui/icons/FormatListBulleted";
// import IntegrationsIcon from "@material-ui/icons/Loop";
// import SettingsIcon from "@material-ui/icons/Settings";
import LogoutIcon from "@material-ui/icons/Cancel";
import StatsIcon from "@material-ui/icons/Timeline";
//import PersonIcon from "@material-ui/icons/AssignmentInd"
import ImportExportIcon from "@material-ui/icons/ImportExport";
import { titles } from "../../constants/constants";
import useStyles from "./stylesSidebarItems";
import { useAuth0 } from "../../hooks/react-auth0-spa";

import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { CircularProgress } from "@material-ui/core";

const SidebarItems = ({ currentItemHandler }) => {
  const classes = useStyles();
  const { user } = useAuth0();
  return !user ? (
    <CircularProgress />
  ) : (
    <div className={classes.list}>
      <ListItem button onClick={() => currentItemHandler("cotizar")}>
        <ListItemIcon className={classes.icon}>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary={titles.cotizar} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("envios")}>
        <ListItemIcon className={classes.icon}>
          <FlightTakeoffIcon />
        </ListItemIcon>
        <ListItemText primary={titles.envios} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("recolecciones")}>
        <ListItemIcon className={classes.icon}>
          <LocalShippingIcon />
        </ListItemIcon>
        <ListItemText primary={titles.recolecciones} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("direcciones")}>
        <ListItemIcon className={classes.icon}>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary={titles.direcciones} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("paquetes")}>
        <ListItemIcon className={classes.icon}>
          <PackageIcon />
        </ListItemIcon>
        <ListItemText primary={titles.paquetes} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("estadisticas")}>
        <ListItemIcon className={classes.icon}>
          <StatsIcon />
        </ListItemIcon>
        <ListItemText primary={titles.estadisticas} />
      </ListItem>
      <ListItem button onClick={() => currentItemHandler("cuenta")}>
        <ListItemIcon className={classes.icon}>
          <ImportExportIcon />
        </ListItemIcon>
        <ListItemText primary={titles.cuenta} />
      </ListItem>
      {/* TODO: el correo de aqui hola@drenvio.com */}
      {user.email === "hola@drenvio.com" && (
        <ListItem button onClick={() => currentItemHandler("admin")}>
          <ListItemIcon className={classes.icon}>
            <SupervisorAccountIcon />
          </ListItemIcon>
          <ListItemText primary={titles.admin} />
        </ListItem>
      )}

      {/* <ListItem button onClick={() => currentItemHandler("destinatarios")}>
        <ListItemIcon className={classes.icon}>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText primary={titles.destinatarios} />
      </ListItem> */}

      <ListItem
        button
        onClick={() => currentItemHandler("logout")}
        className={classes.logout}
      >
        <ListItemIcon className={classes.icon}>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary={titles.logout} />
      </ListItem>
    </div>
  );
};

SidebarItems.propTypes = {
  currentItemHandler: propTypes.func,
};

export default SidebarItems;
